@if (templateName && templateName != 'KnBrQuotePageTemplate') {
  <div class="col-lg-12 p-0 float-right">
    @if (showDownload) {
      <div class="float-right font-color-knbr-primary font-size font-text-600">
        <button (click)="downloadQuoteDetailPdf()" class="w-40 btn btn-primary ml-3">
          {{ 'quoteCommon.label.downloadPDF' | cxTranslate }} &nbsp;<i class="fas fa-download pr-2" aria-hidden="true"></i>
        </button>
      </div>
    }
  </div>
}
@if (templateName && templateName === 'KnBrQuotePageTemplate') {
  @if (productCodes && productCodes.length) {
    <div
      class="col-lg-12 pl-0 pr-0 float-left d-flex justify-content-end mb-0"
      >
      @if (!enableCheckboxFlag) {
        <button type="button" class="btn btn-outline-primary col-lg-12" (click)="enableCheckbox()">
          {{ 'quoteCommon.label.downloadPDF' | cxTranslate }}<i class="fas fa-download ml-2" aria-hidden="true"></i>
        </button>
      }
      @if (enableCheckboxFlag) {
        <button type="button" class="btn btn-primary col-lg-12 mr-3" (click)="downloadPdf()" [disabled]="!selectedProductsCodes || (selectedProductsCodes && selectedProductsCodes.length < 1)">
          {{ 'quoteCommon.label.downloadPDF' | cxTranslate }}<i class="fas fa-download ml-2" aria-hidden="true"></i>
        </button>
      }
      @if (enableCheckboxFlag) {
        <button type="button" class="btn btn-outline-primary col-lg-12" (click)="cancelDownload()">
          {{ 'quoteCommon.label.cancel' | cxTranslate }}
        </button>
      }
    </div>
  }
}
